import React, { Component } from 'react';
import {connect} from 'react-redux';
import DatePicker from "react-datepicker";
import ReactPaginate from 'react-paginate';
import SweetAlert from 'sweetalert2-react';
import Select from "react-select";
import { 
    Table,
    InputGroup,
    InputGroupText,
    InputGroupAddon,
    Input,
    Row,
    Col
} from "reactstrap";

import {
    getAllOrders,
    onDismiss,
    orderStatus,
    getStoreOrders
} from '../../../../actions/OrderActions'
import * as Constant from '../../../../constants/AppConstants'
import { 
    getDeliveryName, 
    parseTime, 
    getPayMethod, 
    getPayStatusClass, 
    getLoder, 
    getPayStatus
} from '../../../../utils';

import { ActionBtn,Button } from "../../../../components";
import AccountBox from './AccoutBox';


const PaymentMethodOptions = [
  {value:Constant.PAYMENT_ONLINE, label:"Online"},
  {value:Constant.PAYMENT_COD, label:"COD"},
//   {value:Constant.PAYMENT_CARD_ON_DELIVERY, label:"Card on delivery"}
]

class Accounts extends Component {

    constructor(props){
        super(props);

        this.state = { 
            offset: 0,
            limit:10,
            status:null,
            selected:'',
            dialogue:false,
            startDate:null,
            endDate:null,
            paymentMethod:null,
            search: '',
            orders:[]
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let skip = selected * this.state.limit
        this.setState({offset: skip});
        this.fetchOrders(skip)
    }

    handleChange = (status,id) =>{
        this.setState({
            selected:id,
            sta:status,
            dialogue:true
        })
    }

    handleDateChange = (date, name)=>{
        this.setState({[name]:date})
    }

    onStatus = () => {
        this.props.onChangeStatus(this.state.selected,this.state.status);
        this.setState({dialogue:false})
    }

    onDismissPopup =()=>{
        this.fetchOrders()
        this.props.onDismiss();
    }

    fetchOrders = (skip=null)=>{
        const {isStore, store} = this.props
        const {
            status, 
            offset, 
            limit, 
            startDate, 
            endDate, 
            search, 
            paymentMethod
        } = this.state

        var data = {
            status, 
            offset, 
            limit, 
            startDate, 
            endDate, 
            search, 
            paymentMethod,
            allOrders: true
        }

        if(skip != null){
            data = {...data, offset:skip}
        }

        if(paymentMethod){
            data = {...data, paymentMethod:paymentMethod.value}
        }

        if(startDate){
            data = {...data, startDate:startDate.format('YYYY-MM-DD')}
        }

        if(endDate){
            data = {...data, endDate:endDate.format('YYYY-MM-DD')}
        }


        if(isStore){
            data = {...data, store:store.id}
            this.props.onGetStoreOrders(data)
        }else{
            this.props.onGetOrders(data)
        }
    }

    componentDidMount() {
       this.fetchOrders()
    }

    static getDerivedStateFromProps(nextProps, prevState){

        if(nextProps.isStore){
            return {...prevState, orders:nextProps.store_orders}
        }

        if(!nextProps.isStore){
            return {...prevState, orders:nextProps.all_orders}
        }

        return {...prevState}
    }

    render() { 
        const {orders} = this.state;

        return ( 
            <div>
                <div className="content">
                    <div className={getLoder(this.props.loading)} />
                    <div className="common-filter-wrapper mb-2">
                        <Row className="align-items-center">
                            <Col md='3'>
                                <InputGroup className="filter-search mr-2">
                                    <Input  
                                        placeholder="Search"  
                                        type="text" 
                                        value={this.state.search} 
                                        onChange={(e)=>this.setState({search:e.target.value})}/>
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText>
                                            <i className="icon-search-find" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col md='3'>
                                <Select 
                                    placeholder="Payment Method" 
                                    options={PaymentMethodOptions} 
                                    onChange={(e)=>this.setState({paymentMethod:e})}
                                    value={this.state.paymentMethod}/>
                            </Col>
                            <Col md='3'>
                                <DatePicker 
                                    className="form-control"
                                    selected={this.state.startDate}
                                    onChange={(e)=>this.handleDateChange(e, 'startDate')}
                                    placeholderText="Date from"/>
                            </Col>
                            <Col md='3'>
                                <DatePicker 
                                    className="form-control"
                                    selected={this.state.endDate}
                                    onChange={(e)=>this.handleDateChange(e, 'endDate')}
                                    placeholderText="Date end"/>
                            </Col>
                            <Col md='2'>
                                <Button 
                                    className="btn-submit"
                                    onClick={()=>this.fetchOrders(0)}>Filter</Button>
                            </Col>
                        </Row>
                    </div>
                    {/* <AccountBox/> */}
                    <div className="table-product-wrapper table-orders">
                        <Table>
                            <thead>
                                <tr>
                                    <th>SI.NO</th>
                                    <th>Order ID</th>
                                    <th>Order Placed</th>
                                    <th>Delivery Time</th>
                                    <th>Customer Name</th>
                                    {!this.props.isStore? <th>Store</th>:null}
                                    <th>Payment Status</th>
                                    <th>Payment Method</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(orders &&orders.length > 0) && orders.map((order,index) =>(
                                <tr key={index}>
                                    <td>{index+1}</td>
                                    <td>
                                        <p>{order.order_id}</p>
                                        <p className="small">
                                            {getDeliveryName(order.delivery_mode)}
                                        </p>
                                    </td>
                                    <td>
                                        {order.order_time}
                                    </td>
                                    <td>
                                        {order.date} {parseTime(order.from)}-{parseTime(order.to)}
                                    </td>
                                    <td>
                                        <p>{order.customer.first_name +' '+ order.customer.second_name}</p>
                                        <p className="small">{order.customer.mobile}</p>
                                    </td>
                                    {!this.props.isStore? <th>
                                        <p>{order.store.title}</p>
                                    </th>:null}
                                    <td>
                                        {getPayStatus(order.payment_status)}
                                    </td>
                                    <td>
                                        <span className={getPayStatusClass(order.payment_mode)}>
                                            {getPayMethod(order.payment_mode)}
                                        </span> 
                                    </td>
                                    
                                    <th>
                                        <p>{order.final_amount?order.store.currency.symbol +' '+ order.final_amount  :'-'} </p>
                                    </th>
                                   
                                </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                    {/* <Button className="fixed-yellow">Add offline order</Button> */}
                    <div className="pagination-wrapper">
                            <ReactPaginate previousLabel={<i className="fas fa-angle-left"></i>}
                            nextLabel={<i className="fas fa-angle-right"></i>}
                            pageLinkClassName={"page-link"}
                            breakClassName={"break-me"}
                            pageCount={Math.ceil(this.props.count/this.state.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            activeClassName={"active"} />
                    </div>
                </div>
                <SweetAlert
                    show={this.state.dialogue }
                    onConfirm={this.onStatus}
                    onCancel = {() => this.setState({ dialogue: false })}
                    title= {'Are you sure?'}
                    text="Change status"
                    type= {'warning'}
                    showCancelButton= {true}
                    confirmButtonText= {'Yes, Confirm it!'}
                    cancelButtonText= {'No, keep it'}/>
                <SweetAlert
                    show={this.props.status && this.props.popup}
                    title="Success"
                    text={this.props.message}
                    onConfirm={this.onDismissPopup}/>
                <SweetAlert
                    show={ !this.props.status && this.props.popup}
                    title="Error"
                    type="error"
                    text={this.props.message}
                    onConfirm={this.onDismissPopup}/>
            </div>
        );
    }
}

Accounts.defaultProps = {
    all_orders:[]
}

const mapStateToProps = (state) => ({
    loading:state.orderReducer.loading,
    all_orders:state.orderReducer.all_orders,
    count:state.orderReducer.count,
    status:state.orderReducer.status,
    message:state.orderReducer.message,
    popup:state.orderReducer.popup,
    store:state.storeUserReducer.store,
    store_orders: state.orderReducer.store_orders,
})

const mapDispatchToProps = (dispatch) => ({
    onGetOrders:(data)=> {
        dispatch(getAllOrders(data))
    },
    onDismiss:()=>{
        dispatch(onDismiss());
    },
    onChangeStatus:(order_id,status)=>{
        dispatch(orderStatus(order_id,status))
    },
    onGetStoreOrders:(data)=> {
        dispatch(getStoreOrders(data))
    },
})

export default connect(mapStateToProps,mapDispatchToProps)(Accounts);